module.exports = __webpack_public_path__ + "static/media/nine.dc2da5d3.jpg";